import request from '@/api/request'
import store from '@/store'

const resolveHeaders = () => {
  const region = store.getters.region || store.getters.defaultRegion
  const brand = store.getters.brand || store.getters.defaultBrand
  return {
    'X-Brand': brand,
    'X-Region': region,
  }
}

export function traceMonitoringSearch(data) {
  return request({
    url: '/traceMonitor/search',
    method: 'post',
    headers: resolveHeaders(),
    data,
  })
}

export function traceMonitoringCount(data) {
  return request({
    url: '/businessLogMonitor/count',
    method: 'post',
    headers: resolveHeaders(),
    data,
  })
}

export function traceMonitoringGetErrorPayload(index, id) {
  return request({
    url: `/traceMonitor/ERR/payload/${index}/${id}`,
    method: 'get',
    headers: resolveHeaders(),
  })
}

export function traceMonitoringDecodeProofOfPurchase(index, id) {
    return request({
        url: `/traceMonitor/decodeProofOfPurchase/${index}/${id}`,
        method: 'get',
        headers: resolveHeaders(),
    })
}

export function traceMonitoringDecodeProofOfRevocation(index, id) {
    return request({
        url: `/traceMonitor/decodeProofOfRevocation/${index}/${id}`,
        method: 'get',
        headers: resolveHeaders(),
    })
}

export function traceMonitoringDecodeProofOfTermination(index, id) {
    return request({
        url: `/traceMonitor/decodeProofOfTermination/${index}/${id}`,
        method: 'get',
        headers: resolveHeaders(),
    })
}

export function traceMonitoringDecodeStateReport(data) {
  return request({
    url: '/businessLogMonitor/decodeStateReport',
    method: 'post',
    headers: resolveHeaders(),
    data,
  })
}

export function traceMonitoringCleanUp(cleanUpTime) {
  return request({
    url: `/update/cleanUp/${cleanUpTime}`,
    method: 'post',
    headers: resolveHeaders(),
  })
}

export function traceMonitoringGetCleanUp() {
  return request({
    url: 'get/cleanUp',
    method: 'get',
    headers: resolveHeaders(),
  })
}

